import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ImagesActions } from '../../../actions';
import {Submit} from '../../Form';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faSave, faPlusCircle, faMinusCircle} from '@fortawesome/fontawesome-free-solid';

class CopiesLayer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            copies: 1,
            reset: null,
            printed: 0
        }

        this.minus = this.minus.bind(this);
        this.plus = this.plus.bind(this);
        this.save = this.save.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        const {copies, show, printed} = props;

        // reset state copies if props copies changed 
        // or when show props change to true 
        // (parent component change it to show this component)
        if(copies === state.copies && show === false && printed === state.printed) return null;

        return {
            copies: Math.max(copies, printed),
            printed: printed
        }
    }

    plus() {
        const newState = {...this.state};
        newState.copies += 1;

        this.setState(newState);
    }

    minus() {
        const {copies, printed} = this.state;
        if(copies <= Math.max(printed, 1)) return;

        const newState = {...this.state};
        newState.copies -= 1;

        this.setState(newState);
    }

    save() { 
        const {dispatch, copies, eventID, imageID, onClose} = this.props;

        if(this.state.copies === copies) return;
        dispatch(ImagesActions.updateImage(eventID, imageID, {copies: this.state.copies}));
        onClose();
    }

    render() {
        const {images, imageID} = this.props;

        return (
            <div id="updateCopies" className="imgLayer">
                <div className="title">
                    מספר עותקים
                </div>
                <div className="action">
                    <span className="buttons" onClick={this.plus}><FontAwesomeIcon icon={faPlusCircle} /></span>
                    <span className="copiesData">{this.state.copies}</span>
                    <span className="buttons" onClick={this.minus}><FontAwesomeIcon icon={faMinusCircle} /></span>
                </div>
                <Submit
                    className="save"
                    icon="faSave"
                    text="שמירה"
                    onClick={this.save}
                    process={images.updateImageProcessList && images.updateImageProcessList[imageID]}
                />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        images: state.imagesReducer
    }
}

const CopiesLayerWithRedux = connect(mapStateToProps)(CopiesLayer);

export {CopiesLayerWithRedux as CopiesLayer};


// WEBPACK FOOTER //
// ./src/components/EventPage/images/CopiesLayer.jsx